import { render } from "./SettingsStub.vue?vue&type=template&id=438e3f57&scoped=true"
import script from "./SettingsStub.vue?vue&type=script&lang=js"
export * from "./SettingsStub.vue?vue&type=script&lang=js"

import "./SettingsStub.vue?vue&type=style&index=0&id=438e3f57&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438e3f57"]])

export default __exports__